import { subDays } from 'date-fns';
import { pathOr } from 'ramda';

import { TValidator } from './types';

export const previousDayInWeek = (dateFieldName: string): TValidator => (value: Date, allValues: any) => {
  const date = pathOr(undefined, dateFieldName.split('.'), allValues);
  if (!date || !value || subDays(date, 1).getDay() === value.getDay()) {
    return undefined;
  }

  return 'Given date in not a previous day in week from the provided one';
};
